import { Cell } from "./Cell";
import { DiscountStatus } from "views/discounts/components/DiscountStatus";
import { ApplicantOrInvitee } from "../types";
import { AppliedDiscountInfo, Money } from "shared/types";

type ApplicantWithDiscount = ApplicantOrInvitee & {
  discount_info?: AppliedDiscountInfo & {
    final_amount?: Money;
  };
};

interface DiscountCellProps {
  applicant: ApplicantWithDiscount;
  setDiscountModal: (v: { email: string; id: number } | null) => void;
  handleCancelDiscount: (applicantId: number) => void;
  isActiveDiscounts: boolean;
  alwaysAllowCustomDiscounts?: boolean;
}

export const DiscountCell = ({
  applicant,
  setDiscountModal,
  handleCancelDiscount,
  isActiveDiscounts,
  alwaysAllowCustomDiscounts = false
}: DiscountCellProps) => {
  return (
    <Cell isFirst isDataCell>
      <div className="flex gap-2 items-center w-full">
        <DiscountStatus
          applicant={{
            id: applicant.id!,
            application_fee_status: applicant.application_fee_status,
            application_status: applicant.application_status,
            discount_info: applicant.discount_info
          }}
          onApplyDiscountClick={() => {
            setDiscountModal({
              email: applicant.email,
              id: applicant.id!
            });
          }}
          onCancelDiscountClick={handleCancelDiscount}
          isActiveDiscounts={isActiveDiscounts}
          alwaysAllowCustomDiscounts={alwaysAllowCustomDiscounts}
        />
      </div>
    </Cell>
  );
};
